import axiosInstance from "../plugins/axiosInstance";

export class BaseService {
  constructor(baseUrl) {
    if (!baseUrl) {
      throw new Error("BaseService requires a base URL.");
    }

    const apiBaseUrl =
      process.env.REACT_APP_API_BASE_URL ||
      "https://api-gama.usios.valkeon.com"; // Read from environment

    if (!apiBaseUrl) {
      console.warn(
        "REACT_APP_API_BASE_URL is not defined. Using localStorage as a simulated API."
      );
    }

    this.apiBaseUrl = apiBaseUrl;
    this.baseUrl = apiBaseUrl ? `${apiBaseUrl}${baseUrl}` : baseUrl;
  }

  async find(params = {}) {
    if (this.apiBaseUrl) {
      try {
        const response = await axiosInstance.get(this.baseUrl, { params });
        return response.data;
      } catch (error) {
        this.handleError(error);
      }
    } else {
      return this.simulateLocalStorageRead(params);
    }
  }

  async findOne(id) {
    if (!id) throw new Error("findOne requires an ID.");
    if (this.apiBaseUrl) {
      try {
        const response = await axiosInstance.get(`${this.baseUrl}/${id}`);
        return response.data;
      } catch (error) {
        this.handleError(error);
      }
    } else {
      return this.simulateLocalStorageReadById(id);
    }
  }

  async create(data) {
    if (this.apiBaseUrl) {
      try {
        const response = await axiosInstance.post(this.baseUrl, data);
        return response.data;
      } catch (error) {
        this.handleError(error);
      }
    } else {
      return this.simulateLocalStorageCreate(data);
    }
  }

  async updateOne(id, data) {
    if (!id) throw new Error("updateOne requires an ID.");
    if (this.apiBaseUrl) {
      try {
        const response = await axiosInstance.put(this.baseUrl, { ...data, id });
        return response.data;
      } catch (error) {
        this.handleError(error);
      }
    } else {
      return this.simulateLocalStorageUpdate(id, data);
    }
  }

  async delete(id) {
    if (!id) throw new Error("delete requires an ID.");
    if (this.apiBaseUrl) {
      try {
        const response = await axiosInstance.delete(`${this.baseUrl}/${id}`);
        return response.data;
      } catch (error) {
        this.handleError(error);
      }
    } else {
      return this.simulateLocalStorageDelete(id);
    }
  }

  handleError(error) {
    console.error("API Error:", error.response || error.message);
    throw error.response ? error.response.data : error;
  }

  getClient() {
    return axiosInstance;
  }

  // LocalStorage Simulation

  simulateLocalStorageRead(params) {
    const data = JSON.parse(localStorage.getItem(this.baseUrl) || "[]");
    // if (params && Object.keys(params).length > 0) {
    //   // Filter based on params (simple implementation)
    //   return data.filter((item) =>
    //     Object.keys(params).every((key) => item[key] === params[key])
    //   );
    // }
    return { items: data };
  }

  simulateLocalStorageReadById(id) {
    const data = JSON.parse(localStorage.getItem(this.baseUrl) || "[]");
    return data.find((item) => item.id === id) || null;
  }

  simulateLocalStorageCreate(newItem) {
    const data = JSON.parse(localStorage.getItem(this.baseUrl) || "[]");
    const newId = Math.random().toString(36).substring(2, 15); // Generate a unique ID
    const createdItem = { ...newItem, id: newId };
    data.push(createdItem);
    localStorage.setItem(this.baseUrl, JSON.stringify(data));
    return createdItem;
  }

  simulateLocalStorageUpdate(id, updatedItem) {
    const data = JSON.parse(localStorage.getItem(this.baseUrl) || "[]");
    const index = data.findIndex((item) => item.id === id);
    if (index === -1) throw new Error("Item not found.");
    data[index] = { ...data[index], ...updatedItem };
    localStorage.setItem(this.baseUrl, JSON.stringify(data));
    return data[index];
  }

  simulateLocalStorageDelete(id) {
    const data = JSON.parse(localStorage.getItem(this.baseUrl) || "[]");
    const updatedData = data.filter((item) => item.id !== id);
    if (data.length === updatedData.length) throw new Error("Item not found.");
    localStorage.setItem(this.baseUrl, JSON.stringify(updatedData));
    return { success: true };
  }
}
